<template>
	<div>
		<a-row type="flex" class="mb-5">
			<a-col :span="24">
				<is-loading :isLoading="defaultProfileLoading" />
				<detail-title
					:networks="networkList"
					:detail="defaultProfile"
					v-if="!!defaultProfile && !defaultProfileLoading"
					@networkTitleChange="networkTitleChange"
				/>
			</a-col>
		</a-row>

		<a-row type="flex">
			<a-col :span="24">
				<div class="card-container">
					<a-tabs type="card" defaultActiveKey="posts" class="post-list">
						<a-tab-pane tab="Posts" key="posts">
							<div class="px-3">
								<a-row type="flex">
									<a-col :span="24">
										<detail-search
											:detailId="defaultDetailId"
											v-if="
												defaultDetailId !== 0 &&
													!!defaultProfile &&
													!defaultProfileLoading
											"
										/>
									</a-col>
								</a-row>
							</div>
						</a-tab-pane>
						<!-- STORIES **NEW** ---------------------->
						<a-tab-pane tab="Stories" key="stories">
							<div class="px-3">
								<a-row type="flex">
									<a-col :span="24">
										<detail-storie-search
											:detailId="defaultDetailId"
											v-if="
												defaultDetailId !== 0 &&
													!!defaultProfile &&
													!defaultProfileLoading
											"
										/>
									</a-col>
								</a-row>
							</div>
						</a-tab-pane>
						<!-- /STORIES **NEW** ---------------------->
						<a-tab-pane tab="Activity" key="activity">
							<div class="px-3">
								<detail-activity
									:detailId="defaultDetailId"
									v-if="
										defaultDetailId !== 0 &&
											!!defaultProfile &&
											!defaultProfileLoading
									"
								/>
							</div>
						</a-tab-pane>
						<a-tab-pane tab="Evolution" key="evolution">
							<div class="px-3">
								<!-- <account-details :accountId="+accountId" :detailId="defaultDetailId" v-if="defaultDetailId !== 0 && !!defaultProfile && !defaultProfileLoading" /> -->
								<account-detail-evolution-chart
									class="mb-2"
									:detailId="defaultDetailId"
									v-if="
										defaultDetailId !== 0 &&
											!!defaultProfile &&
											!defaultProfileLoading
									"
								/>
							</div>
						</a-tab-pane>
					</a-tabs>
				</div>
			</a-col>
		</a-row>
	</div>
</template>
<script>
import * as ACTIONS from '../../store/actions'
import { mapGetters, mapActions } from 'vuex'
import AccountDetailEvolutionChart from '../../components/widgets/Profile/Evolution'
import DetailActivity from '../../components/widgets/Detail/Activity'
import DetailTitle from '../../components/widgets/Detail/NetworkTitle'
import DetailSearch from '../../components/widgets/Detail/Search'
import DetailStorieSearch from '../../components/widgets/Detail/SearchStories'
import IsLoading from '../../components/widgets/loading'

export default {
	name: 'Profile',
	components: {
		DetailTitle,
		DetailSearch,
		DetailStorieSearch,
		DetailActivity,
		IsLoading,
		AccountDetailEvolutionChart,
	},
	data: function() {
		return {
			// DETAILS
			loadingProfile: true,
			loadingDetails: true,
			// PROFILE
			loadingAccount: true,
			loadingNetwork: true,
			accountId: this.$route.params.accountId,
			defaultDetailId: 0,
			defaultProfile: null,
			defaultProfileLoading: true,
			networkList: [],
			aGName: '',
		}
	},
	// PROFILE
	async beforeRouteUpdate(to, from, next) {
		this.accountId = to.params.accountId
		this.loadingAccount = true
		this.loadAccount({ id: this.accountId }).then(e => {
			this.loadingAccount = false
			next()
		})
	},
	created() {
		this.loadDetailList({
			where: { accountId: this.accountId },
		}).then(res => {
			this.networkList = res.map(network => {
				return { id: network.id, name: network.networkName }
			})

			let instagram = res.find(detail => {
				return detail.networkId === 2
			})
			if (!!instagram && res.length > 0) {
				instagram = res.shift()
			}
			if (instagram) {
				this.defaultDetailId = instagram.id
			}
			if (instagram) {
				this.loadProfile(instagram.id)
					.then(profile => {
						this.defaultProfile = profile
					})
					.finally(() => {
						this.defaultProfileLoading = false
					})
			}
		})
	},
	methods: {
		networkTitleChange(id) {
			if (id === this.defaultNetworkChange) {
				return
			}

			this.defaultProfileLoading = true

			this.loadProfile(id)
				.then(profile => {
					this.defaultProfile = profile
				})
				.finally(() => {
					this.defaultDetailId = id
					this.defaultProfileLoading = false
				})
		},

		...mapActions({
			// DETAIL
			loadProfile: ACTIONS.DETAIL.BY_ID,
			loadDetailList: ACTIONS.DETAIL.LIST,
			// PROFILE
			loadAccount: ACTIONS.ACCOUNT.BY_ID,
			loadNetworkList: ACTIONS.NETWORK.LIST,
			accountEvolution: ACTIONS.EVOLUTION.EVOLUTION_POST,
		}),
	},
	computed: {
		...mapGetters([
			'getCurrentProfile',
			'getCurrentAccount',
			'getDetailList',
			'getNetworkList',
		]),
	},
}
</script>

<style lang="scss">
@import './style.module.scss';
</style>
